import drugControl from './drugControl/index'; // 药品管理
import feeDispense from './feeDispense/index'; // 收费发药
import clinicManagement from './clinicManagement/index'; // 诊所管理
import member from './member/index'; // 会员管理
import outPatient from './outPatient/index'; // 门诊
import statistics from './statistics/index'; // 财务
import chainManageStatistics from './chainManageStatistics/index'; // 统计
import memberManagement from './memberManagement/index'; // 会员管理
import systemSet from './systemSet/index'; // 系统设置

import global from './global/index';

export default {
  drugControl,
  feeDispense,
  clinicManagement,
  member,
  outPatient,
  statistics,
  global,
  chainManageStatistics,
  memberManagement,
  systemSet,
};
